import React, { useEffect, useState } from 'react';

const SHOW_DELAY_MS = 250;

const GlobalApiLoader = () => {
  const [active, setActive] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleActivity = (event) => {
      setActive(Boolean(event.detail?.active));
    };

    window.addEventListener('ainsoft:api-activity', handleActivity);
    return () => window.removeEventListener('ainsoft:api-activity', handleActivity);
  }, []);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return undefined;
    }

    const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, [active]);

  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[300]">
      <div className="h-1 w-full overflow-hidden bg-primary/10">
        <div className="h-full w-1/2 animate-[ainsoft-loader-slide_1.1s_ease-in-out_infinite] rounded-r-full bg-primary shadow-[0_0_12px_rgba(70,149,90,0.55)]" />
      </div>

      <div className="mx-auto mt-3 flex w-fit items-center gap-3 rounded-full border border-primary/20 bg-white/95 px-4 py-2 text-sm font-semibold text-gray-700 shadow-lg backdrop-blur">
        <span className="relative flex h-5 w-5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary/35" />
          <span className="relative inline-flex h-5 w-5 animate-spin rounded-full border-2 border-primary/25 border-t-primary" />
        </span>
        Please wait, loading...
      </div>
    </div>
  );
};

export default GlobalApiLoader;
